import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Typography, Icon } from "witmeg-ui-system";
import "./LayoutTemplate.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCartV3, updateCartItemQuantity } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../assets/deal.png"
import arrow from "../../assets/arrow-right.svg"
import check from "../../assets/check.svg"
import arrowBlack from "../../assets/arrow-black.svg"
import heart from "../../assets/fvrt.svg"
import fvrt from "../../assets/heart.svg"
import { addData, getAllData, setOrderCartItems, setOrderData, setOrderEmpty, setRestaurantMenuData } from '../../../../../../../redux/resturantWidgetSlice';
import deleteIc from "../../assets/trash.svg"
import star from "../../assets/star.svg"
import spiceImage from "../../assets/spice.svg"
import config from "react-global-configuration";


import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"
import DeletePopup from '../Cart/DeletePopup';
import { addItemToWishList } from '../../../../../utilities/apiRequests/witmegRetailPaxServerRequests';
import { setSelectedOffer } from '../../../../../../../redux/companyDataSlice';

const LayoutTemplateV3 = ({ layout, headerText, onClick, items, showHeader, limited = true, setItems, from = "ALL", currentPage = 1, setTempData, hideFav = false, setAllData, itemRefs, category }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isIncreasing, setIsIncreasing] = useState(false)
    const [isDecreasing, setIsDeccreasing] = useState(false)



    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { currency, orderCartData,
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const currencyFormat = getCurrencyFormat(currency);
    const [data, setData] = useState(null)
    const [categories, setCategories] = useState([])
    const [dataItems, setDataItems] = useState([])


    useEffect(() => {
        getAllData().then((result) => {
            setData(result);
            let cat = result ? result?.data?.Categories : []
            let datItem = result ? result?.data?.Items : []
            setCategories(cat)
            setDataItems(datItem)
        });
    }, []);

    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const getPromoPrice = (price) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.Delivery;
                break;
            case "table":
                priceValue = price?.DineIn;
                break;
            default:
                priceValue = price?.Takeaway;
                break;
        }
        return "Save " + currencyFormat(priceValue / 100);
    };
    const getPromoPercentage = (PercentageValue) => {
        let value;
        switch (selectedOrderType) {
            case "delivery":
                value = PercentageValue?.Delivery;
                break;
            case "table":
                value = PercentageValue?.DineIn;
                break;
            default:
                value = PercentageValue?.Takeaway;
                break;
        }
        return value + "% OFF"
    };
    const findItemCountFromCart = (menuItem) => {
        let isAvailable = 0
        if (!orderCartData?.Items) {
            return 0
        }
        if (orderCartData?.Items?.length === 0) {
            return 0
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)
            isAvailable = found.length
        }
        return isAvailable

    }
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsIncreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsIncreasing(false)
        })
    }
    const decreaseQty = (item) => {
        setIsDeccreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsDeccreasing(false)

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "MENU").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsDeccreasing(false)
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "MENU").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const handleWishlist = async (item) => {
        if (item) {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            let category = categories?.find(cat =>
                cat.MenuEntities.some(catOBJ => catOBJ.ID === item?.MenuItemID)
            );
            let updatedItems = dataItems.map((itemval) =>
                itemval.MenuItemID === item.MenuItemID
                    ? { ...itemval, IsFavourite: !item.IsFavourite }
                    : itemval
            );
            setDataItems(updatedItems)
            let menu = await getAllData();
            let updated = {
                ...menu,
                data: {
                    ...menu.data,
                    Items: updatedItems
                }
            };
            await addData(updated)
            dispatch(setRestaurantMenuData({ mainMenuData: updated.data }))
            if (setTempData) {
                setTempData(updatedItems)
            }
            if (setAllData) {
                setAllData(updatedItems)
            }
            if (setItems) {
                let updatedNewItems = items.map((itemval) =>
                    itemval.MenuItemID === item.MenuItemID
                        ? { ...itemval, IsFavourite: !item.IsFavourite }
                        : itemval
                );
                setItems(updatedNewItems);
            }
            if (category) {
                let data = {
                    "ProductName": item?.Title?.en,
                    "ProductID": item?.MenuItemID,
                    "MenuID": category?.MenuID,
                    "SubMenuID": category?.MenuCategoryID,
                    "StoreID": val?.cloudLocationID,
                    "IsLikedByCustomer": !item?.IsFavourite
                }
                const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                await addItemToWishList(data, userId).then((response) => {
                    if (response) {

                    }
                })
            }
        }
    }
    const renderSpiceImages = (level) => {
        const fullImages = Math.floor((level * 2) / 2);
        const hasHalfImage = ((level * 2) % 2) !== 0;
        const images = Array.from({ length: fullImages }, (_, index) => (
            <img key={index} src={spiceImage} alt="spice-level" style={{ width: '16px' }} />
        ));
        if (hasHalfImage) {
            images.push(
                <span key="half" style={{ display: 'flex', width: '10px', overflow: 'hidden' }}>
                    <img src={spiceImage} alt="half-spice-level" style={{ width: '16px' }} />
                </span>
            );
        }

        return images;
    };
    const renderLayout1 = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "").length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)

        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem?.ImageURL ? "fill" : "" }} alt="" src={menuItem?.ImageURL ? menuItem?.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                            onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }}
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                        {isModifierAvailable && <div className="cart-btn-customize" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))

                        }}>
                            Customise <img alt="" src={arrow} />
                        </div>}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)} - Added to cart
                        </div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className='mob-name'><div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                            </div>
                                {itemcount > 0 && <div className='added-btn-mob'>
                                    {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}
                                </div>}
                            </div>
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div></div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                    </div>
                </div>
                <div className="column-right-container">
                    <div className="column-right-container-inner">
                        {itemcount > 0 && !isModifierAvailable ?
                            <div className="quantity">
                                <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isDecreasing && !isIncreasing) {
                                        decreaseQty(item)
                                    }
                                }}>
                                    {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                </div>
                                <div className="qty-cont">
                                    {item?.Quantity.Amount || 0}
                                </div>

                                <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isDecreasing && !isIncreasing) {
                                        increaseQty(item)
                                    }
                                }}>
                                    <Icon name="plus" className="icon" />
                                </div>
                            </div> : <div className="add-to-cart-btn" onClick={() => {
                                if (isLoading !== menuItem?.MenuItemID) {
                                    if (isModifierAvailable) {
                                        dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                                    } else {
                                        addItemToCart(menuItem)
                                    }
                                }
                            }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}
                        {isModifierAvailable && <div className="add-to-cart-btn-custom" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                        }}>
                            Customise
                        </div>}
                    </div>
                </div>

            </div>
        )
    }
    const renderLayout2 = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "")?.length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)
        const dealItem = menuItem?.PriceInfo?.Price.DeliveryPrice === 0 && menuItem?.PriceInfo?.Price.PickupPrice === 0 && menuItem?.PriceInfo?.Price.TablePrice === 0
        const offer = menuItem?.HasPromotions
            ? menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF") ? getPromoPrice(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF")?.DiscountValue) : menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF") ?
                getPromoPercentage(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF").PercentageValue) : "" || ""
            : "";
        return (
            <div className="column"
                style={{ minHeight: config.get('Theme') === 'Hospitality-Default-V3-REGAL' ? 'max-content' : "" }}>
                <div className="item-details">
                    {config.get('Theme') !== 'Hospitality-Default-V3-REGAL' && menuItem?.ImageURL && <div className="item-dela-cont">
                        <img alt="" src={menuItem?.ImageURL ? menuItem?.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                            onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }}
                        />
                        {/* {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>} */}
                        {/* {isModifierAvailable && <div className="cart-btn-customize" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                        }}>
                            Customise <img alt="" src={arrow} />
                        </div>}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}  - Added to cart
                        </div>} */}
                    </div>}
                    <div className="item-des">
                        {menuItem?.HasPromotions && <div className='discount-tag2'>{offer}</div>}
                        <div className={config.get('Theme') !== 'Hospitality-Default-V3-REGAL' ? "item-des-title" : "item-des-title-regal "}>
                            <div className='mob-name'>
                                <div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                                    {config.get('Theme') !== 'Hospitality-Default-V3-REGAL' && <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>}
                                </div>
                            </div>
                            {dealItem && <div className="price-container">
                                {itemcount > 0 && !isModifierAvailable ?
                                    <div className="quantity">
                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                decreaseQty(item)
                                            }
                                        }}>
                                            {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                        </div>
                                        <div className="qty-cont">
                                            {item?.Quantity.Amount || 0}
                                        </div>

                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                increaseQty(item)
                                            }
                                        }}>
                                            <Icon name="plus" className="icon"
                                            />
                                        </div>
                                    </div> :
                                    <div className="add-to-cart-btn" onClick={() => {
                                        if (isLoading !== menuItem?.MenuItemID) {
                                            if (isModifierAvailable) {
                                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))
                                            } else {
                                                addItemToCart(menuItem)
                                            }
                                        }
                                    }}>{isLoading === menuItem?.MenuItemID ? <div className='loader-btn ' /> :
                                        <Icon name="plus" className="icon" />}</div>}
                            </div>}
                        </div>

                        {!dealItem && <div className={config.get('Theme') !== 'Hospitality-Default-V3-REGAL' ? "price-wrapper" : "price-wrapper-regal "}>
                            <div className="price">
                                {menuItem?.HasPromotions ?
                                    menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                    : getThePrice(menuItem?.PriceInfo?.Price)}
                                <div className='old-price-val'>{menuItem?.HasPromotions ?
                                    getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                            </div>
                            <div className="price-container">
                                {itemcount > 0 && !isModifierAvailable ?
                                    <div className="quantity">
                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                decreaseQty(item)
                                            }
                                        }}>
                                            {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                        </div>
                                        <div className="qty-cont">
                                            {item?.Quantity.Amount || 0}
                                        </div>

                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                increaseQty(item)
                                            }
                                        }}>
                                            <Icon name="plus" className="icon" />
                                        </div>
                                    </div> :
                                    <div className="add-to-cart-btn" onClick={() => {
                                        if (isLoading !== menuItem?.MenuItemID) {
                                            if (isModifierAvailable) {
                                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))
                                            } else {
                                                addItemToCart(menuItem)
                                            }
                                        }
                                    }}>{isLoading === menuItem?.MenuItemID ? <div className='loader-btn ' /> :
                                        <Icon name="plus" className="icon" />}</div>}
                            </div>
                        </div>}

                    </div>
                </div>

            </div>
        )
    }
    const renderLayout3 = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "")?.length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)

        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem?.ImageURL ? "fill" : "" }} alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                            onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }}
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                        {isModifierAvailable && <div className="cart-btn-customize" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                        }}>
                            Customise <img alt="" src={arrow} />
                        </div>}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}  - Added to cart
                        </div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className='mob-name'><div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                            </div>
                                {itemcount > 0 && <div className='added-btn-mob'>
                                    {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}
                                </div>}
                            </div>
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div></div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price-container">
                            {<div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div>}
                            {itemcount > 0 && !isModifierAvailable ?
                                <div className="quantity">
                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem?.MenuItemID) {
                                        if (isModifierAvailable) {
                                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                                        } else {
                                            addItemToCart(menuItem)
                                        }
                                    }
                                }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}
                            {isModifierAvailable && <div className="add-to-cart-btn-custom" onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }}>
                                Customise
                            </div>}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const renderLayout4 = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "")?.length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)
        const offer = menuItem?.HasPromotions
            ? menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF") ? getPromoPrice(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF")?.DiscountValue) : menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF") ?
                getPromoPercentage(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF").PercentageValue) : "" || ""
            : "";
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">

                        <img style={{ objectFit: !menuItem?.ImageURL ? "fill" : "" }} alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                            onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }} />
                        {
                            menuItem?.HasPromotions &&
                            <div className='discount-tag'>{menuItem?.ApplicablePromotions.length > 1 ? `${menuItem?.ApplicablePromotions.length} Offers Available` : offer
                            }</div>

                        }

                        {!hideFav && localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' && <div className={menuItem?.IsFavourite ? 'fvrt-cont-like' : 'fvrt-cont'}
                            onClick={() => {
                                handleWishlist(menuItem)
                            }}>
                            <img alt="" src={menuItem?.IsFavourite ? fvrt : heart} className='fvrt-icon' />
                        </div>}
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                        {isModifierAvailable && <div className="cart-btn-customize" onClick={() => {
                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                        }}>
                            Customise <img alt="" src={arrow} />
                        </div>}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}  - Added to cart
                        </div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className='mob-name'><div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}


                            </div>
                                {itemcount > 0 && <div className='added-btn-mob'>
                                    {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}
                                </div>}
                            </div>

                            <div className="price">
                                {menuItem?.HasPromotions ?
                                    menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                    : getThePrice(menuItem?.PriceInfo?.Price)}
                                <div className='old-price-val'>{menuItem?.HasPromotions ?
                                    getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                            </div>
                        </div>
                        <div className='det-cont-wrap'>
                            <div className='dev-left'>
                                <div className='review-cont'>
                                    <img alt='' className='rev-star' src={star} />
                                    <div className='revi-per'>{menuItem?.AggregatedProductRating}</div>
                                    <div className='rev-count'>({menuItem?.TotalReviews})</div>
                                </div>
                                {menuItem?.DishInfo?.Classifications?.SpiceLevel > 0 && <div className="spice-leve-img">{renderSpiceImages(menuItem?.DishInfo.Classifications.SpiceLevel)}</div>}

                            </div>
                            <div className='dev-right'>
                                {menuItem?.DishInfo?.Classifications?.IsVegetarian && <div className="spe-cont">Vegetarian</div>}
                                {menuItem?.DishInfo?.Classifications?.IsHalal && <div className="spe-cont">Halal</div>}

                            </div>
                        </div>
                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>

                        <div className="price-container">
                            <div className="price">
                                {menuItem?.HasPromotions ?
                                    menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                    : getThePrice(menuItem?.PriceInfo?.Price)}
                                <div className='old-price-val'>{menuItem?.HasPromotions ?
                                    getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                            </div>
                            {itemcount > 0 && !isModifierAvailable ?
                                <div className="quantity">
                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem?.MenuItemID) {
                                        if (isModifierAvailable) {
                                            dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                                        } else {
                                            addItemToCart(menuItem)
                                        }
                                    }
                                }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}
                            {isModifierAvailable && <div className="add-to-cart-btn-custom" onClick={() => {
                                dispatch(setSelectedOffer(menuItem.MenuItemID + "/new"))


                            }}>
                                Customise
                            </div>}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const getLayout = (menuItem) => {
        let layoutComponent;

        switch (layout) {
            case "layout1":
                layoutComponent = renderLayout1(menuItem);
                break;

            case "layout2":
                layoutComponent = renderLayout2(menuItem);
                break;
            case "layout3":
                layoutComponent = renderLayout3(menuItem);
                break;
            case "layout4":
                layoutComponent = renderLayout4(menuItem);
                break;
            default:
                layoutComponent = renderLayout1(menuItem);
                break;
        }

        return layoutComponent;
    };
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        setIsLoading(selectedItem.MenuItemID)
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userDetails = localStorage.getItem('fullUserDetails')
        let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
        let customer = {
            ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            Name: {
                DisplayName: userDetails ? parsedUserDetails.UserName : "",
                FirstName: userDetails ? parsedUserDetails.FirstName : "",
                LastName: userDetails ? parsedUserDetails.LastName : "",
            },
            Email: userDetails ? parsedUserDetails.Email : "",
            IsPrimaryCustomer: true

        }
        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        let cartObject = {
            "CartItemID": selectedItem.MenuItemID,
            "Title": selectedItem.Title?.en,
            "CustomerID": customerID,
            "Quantity": {
                "Unit": "pcs",
                "Amount": 1
            },
            "DefaultQuantity": {
                "Amount": 1,
                "Unit": "pcs"
            },
            "CustomerRequests": {
                "Allergy": {
                    "Allergens": [],
                    "Instructions": ""
                },
                "SpecialInstructions": ""
            },
            SelectedModifierGroups: [],
            ValueID: uuidv4(),
            ID: "",
            ModifierGroupRules: selectedItem.ModifierGroupRules,
            Image: selectedItem.ImageURL,
            PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1)

        }
        let cart = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
            "StoreID": val.cloudLocationID,
            "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            "OrderingPlatformType": "RETAILPACX",
            "CountryISOCode": "GB",
            "OrganizationID": val.organizationID,
            "CloudLocationID": val.cloudLocationID,
            "Name": companyDetails.shopName,
            "OrderFullFilmentType": getOrderType(),
            "Customers": [customer],
            Cart: cartObject,
            OrderType: "MENU"
        }
        await addToCart(cart).then((res) => {
            if (res) {
                getCartItemsToCartV3(customerID, val.cloudLocationID, "MENU").then((response) => {
                    if (response) {
                        dispatch(setOrderData(response))
                        setIsLoading("")

                    }
                })
            }
        })
    }
    return (
        <div className="Hospitality-LayoutV3-Template-Menu">
            {showHeader && <div className='textheader-container'>
                <div className="title-menu-2" >{headerText || ""}</div>
                {limited && <div className='view-all-container'
                    onClick={onClick}
                >   <div className='view-all-text'>View All</div>
                    <img alt='' src={arrowBlack} className='icon' /></div>}
            </div>}
            <div className={layout} ref={(el) => (itemRefs.current[category.MenuCategoryID] = el)}>
                {items.map(((menuItem, key) => {
                    return (
                        <div className="column-styles" key={key}>
                            {getLayout(menuItem)}
                        </div>
                    )
                }))}
            </div>
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
        </div >
    )
}
export default LayoutTemplateV3